module.exports = ".responsive{width:100%;height:auto;max-height:800px;max-width:1000px;display:block;margin-right:auto;margin-left:auto}\n"